import { alpha, styled } from "@mui/material";
import { DataGrid, faIR, gridClasses } from "@mui/x-data-grid";
import { forwardRef, useImperativeHandle, useState } from "react";

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  overflowX: "auto",
  border: 0,
  backgroundColor: theme.palette.grey.gb,
  minHeight: "400px !important", // 👈 حداقل ارتفاع مورد نظر
  "& .boldRow": {
    fontWeight: "900 !important",
    color: theme.palette.primary.main,
  },
  "& .MuiPaginationItem-root": {
    lineHeight: "15px",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  "&:not(.no-rows) .MuiDataGrid-main": {
    borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "none !important",
    margin: "0 auto",
  },
  "& .MuiDataGrid-withBorderColor": {
    borderColor: "transparent !important",
  },
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey.gs,
  },
  [`& .${gridClasses.row}`]: {
    "&:hover, &.Mui-hovered": {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
    "&.Mui-selected": {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY + theme.palette.action.selectedOpacity),
      "&:hover, &.Mui-hovered": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY + theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity
        ),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY + theme.palette.action.selectedOpacity),
        },
      },
    },
  },
}));

const PAGE_SIZE = 6;

const AVCDataGrid = forwardRef((props, ref) => {
  const {
    paginationModel: externalPaginationModel,
    onPaginationModelChange: externalPaginationChange,
    rowsPerPage,
    ...restProps
  } = props;
  const [internalPaginationModel, setInternalPaginationModel] = useState({
    pageSize: rowsPerPage || PAGE_SIZE,
    page: 0,
  });

  // 📌 اگر props دادی، استفاده کن؛ اگر نه، internal رو بده
  const paginationModel = externalPaginationModel ?? internalPaginationModel;
  const onPaginationModelChange = externalPaginationChange ?? setInternalPaginationModel;

  useImperativeHandle(ref, () => ({
    setPageSize: (newSize) => {
      if (externalPaginationChange) {
        externalPaginationChange((prev) => ({ ...prev, pageSize: newSize }));
      } else {
        setInternalPaginationModel((prev) => ({ ...prev, pageSize: newSize }));
      }
    },
  }));

  return (
    <StripedDataGrid
      rowHeight={48}
      columnHeaderHeight={48}
      disableSelectionOnClick
      disableColumnMenu
      hideFooterSelectedRowCount
      // paginationModel={paginationModel}
      // onPaginationModelChange={setPaginationModel}
      paginationModel={paginationModel}
      onPaginationModelChange={onPaginationModelChange}
      pageSizeOptions={[PAGE_SIZE]}
      getRowClassName={(params) => {
        if (
          (params.row.hasOwnProperty("readByReceiver") && !params.row.readByReceiver) ||
          (params.row.hasOwnProperty("readBySender") && !params.row.readBySender)
        ) {
          return params.indexRelativeToCurrentPage % 2 === 0 ? "boldRow even" : "boldRow odd";
        }
        return params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd";
      }}
      localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
      {...restProps}
    />
  );
});

export default AVCDataGrid;

// import { alpha, styled } from "@mui/material";
// import { DataGrid, faIR, gridClasses } from "@mui/x-data-grid";

// const ODD_OPACITY = 0.2;

// const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
//   overflowX: "auto",
//   border: 0,
//   backgroundColor: theme.palette.grey.gb,
//   borderRadius: 16,
//   "& .boldRow": {
//     fontWeight: "900 !important",
//     color: theme.palette.primary.main,
//   },
//   "& .MuiPaginationItem-root": {
//     lineHeight: "15px",
//     borderRadius: 8,
//     justifyContent: "center",
//     alignItems: "center",
//     display: "flex",
//   },
//   "& .MuiDataGrid-footerContainer": {
//     borderTop: "none !important",
//     margin: "0 auto",
//   },
//   "& .MuiDataGrid-withBorderColor": {
//     borderColor: "transparent !important",
//   },
//   [`& .${gridClasses.row}.even`]: {
//     backgroundColor: theme.palette.grey.gs,
//   },
//   [`& .${gridClasses.row}`]: {
//     "&:hover, &.Mui-hovered": {
//       backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
//       "@media (hover: none)": {
//         backgroundColor: "transparent",
//       },
//     },
//     "&.Mui-selected": {
//       backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY + theme.palette.action.selectedOpacity),
//       "&:hover, &.Mui-hovered": {
//         backgroundColor: alpha(
//           theme.palette.primary.main,
//           ODD_OPACITY + theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity
//         ),
//         // Reset on touch devices, it doesn't add specificity
//         "@media (hover: none)": {
//           backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY + theme.palette.action.selectedOpacity),
//         },
//       },
//     },
//   },
// }));

// const PAGE_SIZE = 6;

// const AVCDataGrid = (props) => {

//   return (
//     <>
//       <StripedDataGrid
//         rowHeight={48}
//         disableSelectionOnClick
//         disableColumnMenu
//         hideFooterSelectedRowCount
//         pageSizeOptions={[PAGE_SIZE]}
//         getRowClassName={(params) => {
//           if ((params.row.hasOwnProperty("readByReceiver") && !params.row.readByReceiver)||(params.row.hasOwnProperty("readBySender") && !params.row.readBySender)) {
//             return params.indexRelativeToCurrentPage % 2 === 0 ? "boldRow even" : "boldRow odd";
//           }
//           return params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd";
//         }}
//         localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
//         {...props}
//       />
//     </>
//   );
// };

// export default AVCDataGrid;
